// src/api/services/userService.ts
import api from "../axios";

export interface LocationDto {
  address: string;
  street: string;
  streetNumber: string;
  zip: string;
  city: string;
  state: string;
  placeId: string;
}

export interface UserProfileDto {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  middleName?: string;
  phone?: string;
  dob?: string;
  location?: LocationDto;
  /** True when the tenant has an active bank payment method without an ACH mandate. */
  hasBankWithoutMandate?: boolean;
}

// Fetch full profile
export function getMe() {
  return api.get<UserProfileDto>("/users/me");
}

// Update profile: address as top‐level string
export function updateUserProfile(payload: {
  firstName: string;
  lastName: string;
  middleName?: string;
  phone?: string;
  email: string;
  dob?: string;
  address?: string;
}) {
  return api.put("/users/me", payload);
}